import { HeidiLoader } from '@heidi/design-system/heidi-loader';
import { useNavigationFeedbackCheckpoint } from './use-navigation-feedback-checkpoint';

/** Shared by the outgoing page's cover and the incoming route's lazy fallback. */
export const NavigationLoadingView = () => {
  useNavigationFeedbackCheckpoint();
  return (
    <div
      className="flex h-full min-h-0 flex-1 items-center justify-center bg-surface-shell"
      aria-busy="true"
      data-testid="navigation-loading-view"
    >
      <HeidiLoader />
    </div>
  );
};
